import { RiPushpin2Fill, RiPushpin2Line, RiQuestionLine } from "@remixicon/react";
import { Button } from "@screener/uikit/components/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@screener/uikit/components/tooltip";
import { CARD_PIN_UNREAD_LABEL, cardPinButtonLabel } from "./card-pin-labels";

/**
 * Значок закрепления карточки в шапке (§9 1.52, §65; design Д8). Часть
 * экрана, не UIKit: знает про инструмент. Вид и размер — как у значка порога
 * рядом. Пока список закреплений не прочитан, значок бледный, без
 * `aria-pressed`, и нажатие перечитывает список (решает экран).
 */

interface CardPinButtonProps {
  /** Тикер карточки (`tickerLabel`) — им названо действие. */
  ticker: string;
  /** Закреплена ли карточка; `null` — список не прочитан. */
  pinned: boolean | null;
  /** Запись или перечитывание этого ключа ещё в пути. */
  busy: boolean;
  onClick: () => void;
}

export function CardPinButton({ ticker, pinned, busy, onClick }: CardPinButtonProps) {
  const label = pinned === null ? CARD_PIN_UNREAD_LABEL : cardPinButtonLabel(ticker, pinned);
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            type="button"
            variant="ghost"
            size="icon-cell"
            aria-label={label}
            {...(pinned === null ? {} : { "aria-pressed": pinned })}
            aria-busy={busy ? true : undefined}
            // Ячейка 24x22 со значком 13 px (§88 п. 5): закреплённая — основным
            // цветом, незакреплённая и непрочитанная — приглушённым.
            className={pinned === true ? "text-foreground" : "text-muted-foreground"}
            onClick={() => {
              if (!busy) {
                onClick();
              }
            }}
          />
        }
      >
        {pinned === null ? (
          <RiQuestionLine aria-hidden="true" />
        ) : pinned ? (
          <RiPushpin2Fill aria-hidden="true" />
        ) : (
          <RiPushpin2Line aria-hidden="true" />
        )}
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
